import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import Committee from './components/Committee';
import Payment from './components/Payment';
import OurStory from './components/OurStory';
import NewsEvents from './components/NewsEvents';
import 'bootstrap/dist/css/bootstrap.min.css';
import PhotoAlbum from './components/PhotoAlbum';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                    <Route path="/committee" element={<Committee />} /> 
                    <Route path="/payment" element={<Payment />} />
                    <Route path="/photo-album" element={<PhotoAlbum />} />

                </Routes>
            </Layout>
        );
    }
}
